import { Box, CircularProgress, Typography } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { animationInterval } from "../../utils/util.js";

const AppointmentTimer = (props) => {
  const { duration, startTime } = props;
  const actualEnd = useMemo(
    () => new Date(startTime?.getTime() + duration * 60000),
    [startTime, duration],
  );
  const [minutesLeft, setMinutesLeft] = useState(duration);

  useEffect(() => {
    setMinutesLeft(Math.round((actualEnd - new Date()) / 60000));
    const controller = new AbortController();
    animationInterval(5000, controller.signal, () => {
      setMinutesLeft(Math.round((actualEnd - new Date()) / 60000));
    });

    return function () {
      controller.abort();
    };
  }, [actualEnd, duration]);

  const color = "primary.main";

  const scale = 0.5;
  const baseSize = 250;
  const size = Math.round(baseSize * scale);
  const bigFont = `${5 * scale}rem`;
  const displayColor = minutesLeft < 0 ? "grey.300" : color;

  return startTime ? (
    <Box
      sx={{
        position: "relative",
        height: "auto",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          position: "relative",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress
          variant="buffer"
          sx={{
            color: displayColor,
            "& .MuiCircularProgress-circle": {
              strokeDasharray: "0.1 2.3",
              strokeDashoffset: "1.2",
              strokeLinecap: "round",
            },
          }}
          size={size}
          thickness={0.6}
          value={100}
        />
        <CircularProgress
          sx={{
            animationDuration: "100ms",
            position: "absolute",
            left: 0,
            color: displayColor,
            "& .MuiCircularProgress-circle": {
              strokeLinecap: "round",
            },
          }}
          variant="determinate"
          size={size}
          thickness={0.6}
          value={minutesLeft >= 0 ? (minutesLeft / duration) * 100 : 100}
        />
      </Box>
      <Box
        sx={{
          position: "absolute",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyItems: "center",
          color: displayColor,
        }}
      >
        <Typography
          sx={{
            fontWeight: "bold",
            fontSize: bigFont,
            marginBottom: 0,
            lineHeight: 1,
          }}
        >
          {Math.abs(minutesLeft ?? 0)}
        </Typography>
        {/* no descriptive text; only show number of minutes. When overdue, color is grey and number is minutes exceeded */}
      </Box>
    </Box>
  ) : null;
};
export default AppointmentTimer;
